<template>
  <div class="newly">
    <div class="form">
      <a-form-model ref="forms" :model="forms" :rules="rules" :label-col="{ span: 7 }" :wrapper-col="{ span: 11 }">
        <!-- 争议解决方式 -->
        <a-form-model-item style="font-weight: 600;" label="争议解决方式" prop="cause_type">
          <a-select placeholder="请选择争议解决方式" :disabled='isEdit("cause_type")' :class='{ "yellow": isEdit("cause_type") }'
            @change="handleTypeChange">
            <a-select-option :value="1">诉讼</a-select-option>
            <a-select-option :value="2">仲裁</a-select-option>
            <a-select-option :value="3" disabled>公证</a-select-option>
            <a-select-option :value="4" disabled>调解</a-select-option>
          </a-select>
        </a-form-model-item>

        <!-- 原告/申请人部分 -->
        <div v-if="forms.cause_type" style="position: relative;border-bottom: 1px solid #ccc;">
          <div v-for="(item, index) in forms.plaintiffs" :key="'plaintiff-' + index">
            <a-form-model-item :colon="false" style="font-weight: 600;height: 20px;"
              :label="forms.cause_type == 1 ? '原告' : '申请人'">
              <a-button v-if="index == 0" style="width: 40px;font-size: 1.25rem;" @click="addInformation('plaintiff')"
                type="link" icon="plus-circle" />
              <a-button v-else style="width: 40px;font-size: 1.25rem;color: red;"
                @click="deleteInformation('plaintiff', index)" type="link" icon="minus-circle" />
            </a-form-model-item>
            <a-form-model-item label="类型" :prop="'plaintiffs.' + index + '.type'"
              :rules="[{ required: true, message: '请选择类型', trigger: 'change' }]">
              <a-select v-model="item.type" placeholder="请选择" :disabled='isEdit("type")'
                :class='{ "yellow": isEdit("type") }'
                @change="() => handleIdentityTypeChange(item, index, 'plaintiffs')">
                <a-select-option :value="1">个人</a-select-option>
                <a-select-option :value="2">企业</a-select-option>
              </a-select>
            </a-form-model-item>

            <a-form-model-item :label="item.type == 1 ? '挂靠企业名称' : '企业名称'"
              :prop="'plaintiffs.' + index + '.company_id'">
              <a-select v-model="item.company_id" :placeholder="item.type == 1 ? '请选择挂靠企业名称' : '请选择企业名称'"
                @change='ChangeName(item.company_id, index)'>
                <a-select-option v-for="it in accuserList" :key="it.id" :value="it.id"
                  :disabled="it.debtors.length == 0 && item.type == 1">{{
                    it.title
                  }}</a-select-option>
              </a-select>
            </a-form-model-item>
            <a-form-model-item label="姓名" :prop="'plaintiffs.' + index + '.name_id'" v-if="item.type == 1">
              <a-select v-model="item.name_id" placeholder="请选择姓名" @change="ChangeName1(item.name_id, index)">
                <a-select-option v-for="item in plaintiff" :key="item.id" :value="item.id">{{
                  item.realname
                }}</a-select-option>
              </a-select>
            </a-form-model-item>
            <a-form-model-item :label="item.type == 2 ? '统一社会信用代码' : '证件号码'" :prop="'plaintiffs.' + index + '.chinaid'">
              <a-input :maxLength="18" :placeholder="item.type == 2 ? '请填写统一社会信用代码' : '请填写证件号码'" v-model="item.chinaid"
                disabled @blur="getSex(item.chinaid, index, 'plaintiffs')" />
            </a-form-model-item>
            <a-form-model-item label="性别" :prop="'plaintiffs.' + index + '.sex'" v-if="item.type == 1">
              <a-select v-model="item.sex" placeholder="请选择" :class='{ "yellow": isEdit("sex") }'>
                <a-select-option :value="1">男</a-select-option>
                <a-select-option :value="2">女</a-select-option>
              </a-select>
            </a-form-model-item>
          </div>
        </div>

        <!-- 被告/被申请人部分 -->
        <div v-if="forms.cause_type">
          <div v-for="(item, index) in forms.defendants" :key="'defendant-' + index">
            <a-form-model-item :colon="false" style="font-weight: 600;height: 20px;margin-top: 10px;"
              :label="forms.cause_type == 1 ? '被告' : '被申请人'">
              <a-button v-if="index == 0" @click="addInformation('defendant')" style="width: 40px;font-size: 1.25rem;"
                type="link" icon="plus-circle" />
              <a-button v-else style="width: 40px;font-size: 1.25rem;color: red;"
                @click="deleteInformation('defendant', index)" type="link" icon="minus-circle" />
            </a-form-model-item>
            <a-form-model-item label="类型" :prop="'defendants.' + index + '.type'"
              :rules="[{ required: true, message: '请选择类型', trigger: 'change' }]">
              <a-select v-model="item.type" placeholder="请选择" :disabled='isEdit("type")'
                :class='{ "yellow": isEdit("type") }'
                @change="() => handleIdentityTypeChange(item, index, 'defendants')">
                <a-select-option :value="1">个人</a-select-option>
                <a-select-option :value="2">企业</a-select-option>
              </a-select>
            </a-form-model-item>
            <a-form-model-item :label="item.type == 2 ? '名称' : '姓名'" :prop="'defendants.' + index + '.realname'">
              <a-input :maxLength="49" v-model="item.realname" :placeholder="item.type == 1 ? '请填写姓名' : '请填写名称'"
                :disabled='isEdit("realname")' :class='{ "yellow": isEdit("realname") }' />
            </a-form-model-item>
            <a-form-model-item :label="item.type == 2 ? '统一社会信用代码' : '证件号码'" :prop="'defendants.' + index + '.chinaid'">
              <a-input :maxLength="18" v-model="item.chinaid" :placeholder="item.type == 2 ? '请填写统一社会信用代码' : '请填写证件号码'"
                :class='{ "yellow": isEdit("chinaid") }' @blur="getSex(item.chinaid, index, 'defendants')" />
            </a-form-model-item>

            <a-form-model-item v-if="item.type == 1" label="性别" :prop="'defendants.' + index + '.sex'">
              <a-select v-model="item.sex" placeholder="请选择" :disabled='true' :class='{ "yellow": isEdit("sex") }'>
                <a-select-option :value="1">男</a-select-option>
                <a-select-option :value="2">女</a-select-option>
              </a-select>
            </a-form-model-item>
          </div>
          <!-- 提交按钮 -->
          <a-form-model-item :wrapper-col="{ span: 14, offset: 6 }">
            <a-popconfirm title="确认提交此条数据吗?" ok-text="确定" cancel-text="取消" @confirm="confirm">
              <a-button type="primary" style="width:148px;">
                提交
              </a-button>
            </a-popconfirm>
            <a-button style=" margin-left: 20px;width:148px;background:#B2C9E1;color:#fff;"
              @click='$router.back(-1)'>取消</a-button>
          </a-form-model-item>
        </div>
      </a-form-model>
    </div>
  </div>
</template>
<script>
import city from "@/assets/js/city.json"
import Validator from "@/assets/js/yz.js"
import { getAccuserAll } from "@/server/api"
import { accuserdebtorlists } from "@/server/subjectAction"
import { mapGetters } from 'vuex'
import { citySort } from '@/assets/js/unit'
import { identityVerification } from '@/server/directory'
function isValidDate(date) {
  return date instanceof Date && !isNaN(date.getTime())
}
export default {
  data() {

    return {
      Validator,
      audit: [],   //在修改中的字段
      options: citySort(city),
      accuserList: [],
      plaintiff: [],
      accuser: {},
      list: [
        {
          id: 1,
          title: '金融借款'
        }, {
          id: 2,
          title: '担保追偿'
        }, {
          id: 3,
          title: '融资租赁'
        }
      ],
      // 基础验证规则
      rules: {
        type: [{ required: true, trigger: 'change', message: '请选择争议解决方式' }]
      },
      edit: false,
      form: {
        //    cause_is_complete: 0,
        // last_compensation_time: "",
        // is_full_pay: 1,
        accuser_id: '',
        // is_role_exact: 1,
        chinaid: '',
        dwell_addr: '',
        addr: '',
        dwell: [],
        citys: [],
        sex: '',
        car_type_id: 0,
      },
      forms: {
        cause_type: '',
        plaintiffs: [
          {
            company_id: '',
            name_id: '',
            realname: '',
            sex: '',
            chinaid: '',
            type: 2
          },
        ],
        defendants: [
          {
            realname: '',
            sex: '',
            chinaid: '',
            type: 1
          }
        ]
      }
    }
  },
  created() {
    this.init(this.$route.query.id)
    getAccuserAll().then((res) => {
      this.accuserList = res.list
    })
  },
  computed: {
    ...mapGetters([
      'APIKEY'
    ])
  },
  watch: {
    forms: {//监听表单变换，刷新表单验证规则
      handler() {
        this.createRules();
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    ChangeName(item, index) {
      this.accuserList.map((res) => {
        if (res.id == item) {
          this.plaintiff = res.debtors
          if (this.forms.plaintiffs[index].type == 2) {
            this.forms.plaintiffs[index].chinaid = res.chinaid
          }
        }
      })
    },
    ChangeName1(item, index) {
      if (this.forms.plaintiffs[index].type == 1) {
        this.plaintiff.map((res) => {
          if (res.id == item) {
            this.forms.plaintiffs[index].chinaid = res.chinaid
            this.getSex(res.chinaid, index, 'plaintiffs')
          }
        })
      }
    },
    // 处理争议解决方式变化
    handleTypeChange(value) {
      this.forms.cause_type = value;
      this.$nextTick(() => {
        this.createRules();
        // 新增：清除争议解决方式字段的错误提示
        this.clearFieldError('type');
      });
    },
    // 处理身份类型变化（核心修改）
    handleIdentityTypeChange(item, index, prefix) {
      // 切换类型，更新 sex
      item.realname = ''
      item.chinaid = ''
      if (item.type == 2) {
        item.sex = '';

      }
      this.$nextTick(() => {
        this.createRules();
        this.clearFieldError(`${prefix}.${index}.type`);
        this.clearFieldError(`${prefix}.${index}.realname`);
        this.clearFieldError(`${prefix}.${index}.chinaid`);
        this.clearFieldError(`${prefix}.${index}.sex`);
      });
    },
    // 新增：清除指定字段的错误提示
    clearFieldError(field) {
      if (this.$refs.forms && this.$refs.forms.clearValidate) {
        // clearValidate 可以清除单个/多个字段的错误状态
        this.$refs.forms.clearValidate(field);
      }
    },
    // 动态验证规则
    createRules() {
      const rules = {
        type: [{ required: true, trigger: 'change', message: '请选择争议解决方式' }]
      };
      // 原告/申请人
      this.forms.plaintiffs.forEach((item, index) => {
        this.addItemRules(rules, item, index, 'plaintiffs');
      });
      // 被告/被申请人
      this.forms.defendants.forEach((item, index) => {
        this.addItemRules(rules, item, index, 'defendants');
      });
      this.rules = rules;
    },

    addItemRules(rules, item, index, prefix) {
      const key = `${prefix}.${index}`;
      const getRealnameMessage = () => {
        const identityType = this.forms[prefix][index].type;
        return identityType === 2 ? '请输入名称' : '请输入姓名';
      };

      const getChinaidMessage = () => {
        const identityType = this.forms[prefix][index].type;
        return identityType === 2 ? '请输入统一社会信用代码' : '请输入证件号码';
      };

      rules[`${key}.realname`] = [
        {
          required: true,
          message: getRealnameMessage(),
          trigger: 'blur'
        }
      ];
      rules[`${key}.chinaid`] = [
        {
          required: true,
          trigger: 'blur',
          message: getChinaidMessage()
        },

      ];

      rules[`${key}.type`] = [
        { required: true, trigger: 'change', message: '请选择类型' }
      ];
      if (item.type == 1 || !item.type) {
        rules[`${key}.sex`] = [
          { required: true, trigger: 'change', message: '请选择性别' }
        ];
      }
    },

    // 添加信息
    addInformation(type) {
      const newItem = {
        realname: '',
        sex: '',
        chinaid: '',
        type: ''
      };
      if (type === 'plaintiff') {
        newItem.type = 2
        this.forms.plaintiffs.push(newItem);
      } else {
        newItem.type = 1
        this.forms.defendants.push(newItem);
      }
      // 重新创建验证规则
      this.$nextTick(() => {
        this.createRules();
      });
    },
    deleteInformation(type, index) {
      if (type == 'plaintiff') {
        this.forms.plaintiffs = this.forms.plaintiffs.filter((_, i) => i !== index)
      } else {
        this.forms.defendants = this.forms.defendants.filter((_, i) => i !== index)
      }
      // 重新创建验证规则
      this.$nextTick(() => {
        this.createRules();
      });
    },
    // 获取性别（根据身份证号）
    getSex(item, index, listType) {
      if (!item) return;
      // 奇数为男，偶数为女
      if (item.length >= 17) {
        const genderNum = parseInt(item.charAt(16));
        if (listType == 'plaintiffs') {
          this.forms.plaintiffs[index].sex = genderNum % 2 === 1 ? 1 : 2;
        } else {
          this.forms.defendants[index].sex = genderNum % 2 === 1 ? 1 : 2;
        }
      }
      this.$nextTick(() => {
        this.createRules();
      });
    },
    citysCg(val) {
      if (this.form.dwell.length == 0) {
        this.form.dwell = val
      }
    },
    AddCg(val) {
      if (this.form.dwell_addr.length == 0) {
        this.form.dwell_addr = this.form.addr
      }
    },
    isEdit(val) {
      let bool = this.audit.filter(ele => {
        return val.split(",").indexOf(ele.field) >= 0
      }).length > 0 ? true : false;
      return bool
    },
    async confirm() {
      this.$refs.forms.validate(async valid => {
        if (valid) {
          let forms = JSON.parse(JSON.stringify(this.forms));
          let id = this.$route.query.id
          if (id) forms.id = id
          forms.plaintiffs.map(e => {
            e.accuser_id = e.type == 1 ? e.name_id : e.company_id
          })
          // 等待所有被告身份核验
          const resultList = await this.IdentityEvent(forms.defendants)
          // 标记是否身份校验异常
          let hasErr = false
          const errMsgArr = []
          resultList.forEach((item) => {
            const { index, res } = item
            if (res && res.check_result === false) {
              hasErr = true
              const errText = `请填写正确的${item.type === 1 ? '身份' : '企业'}信息`;
              errMsgArr.push(`第${index + 1}位${forms.cause_type === 1 ? '被告' : '被申请人'}：${errText}`)
            }
          })
          if (hasErr) {
            this.$message.error(errMsgArr.join('；'))
            return
          }
          // 全部身份校验通过才走保存
          this.$Ajax({
            url: id ? 'debtor/edit' : 'v2/cause/first_add',
            data: forms,
            contentType: "application/json",
            success: (e) => {
              let routeUrl = this.$router.resolve({ "name": "lydetails", params: { "id": Number(e.cause.debtor_id) } });
              window.open(routeUrl.href, '_blank');
              this.reset()
            }
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    IdentityEvent(defendants) {
      return Promise.all(defendants.map((i, index) => {
        return identityVerification({
          type: i.type,
          realname: i.realname,
          chinaid: i.chinaid
        }).then(res => {
          return { sourceItem: i, index, res, type: i.type }
        })
      }))
    },
    reset() {
      this.$refs.forms.resetFields();
      // this.$router.back(-1)
    },
    init(id) {
      this.edit = id ? true : false;
      if (id) {
        this.$Ajax({
          url: 'debtor/info',
          type: 'get',
          data: { id: id },
          success: (res) => {
            let e = res.info;
            this.audit = res.info.audit;
            this.accuser = res.info.accuser || {}
            this.form = {
              accuser_id: e.accuser_id,
              //   cause_is_complete: e.cause_is_complete,
              citys: [e.province, e.city, e.area],
              dwell: e.dwell_province ? [e.dwell_province, e.dwell_city, e.dwell_area] : [e.province, e.city, e.area],
              // last_compensation_time: isValidDate(new Date(e.last_compensation_time)) ? e.last_compensation_time : '',
              // is_role_exact: e.is_role_exact,
              // is_full_pay: e.is_full_pay,
              dwell_addr: e.dwell_addr,
              addr: e.addr,
              type: e.type,
              chinaid: e.chinaid,
              realname: e.realname,
              phone: e.phone,
              sex: e.sex,
              car_type_id: e.car_type_id
            }
          }
        })
      } else {
        this.rules.accuser_id = [{ required: true, trigger: 'change', message: '请选择原告' }]

      }
    }
  }
}
</script>
<style lang="less">
.newly .yellow {
  border: 1px solid #ff9800 !important;
  opacity: 1;
  color: #ccc;
  /* border: 0 none; */
  background: none;
  border-radius: 6px;
}
</style>
<style lang="less" scoped>
.newly {
  .form {
    width: 600px;
    margin: 0 auto;
  }

  background: #fff;
  padding: 60px 26px;
}

.border {
  height: 2px;

  background: #ccc;
}

.Abutton {
  position: absolute;
  right: -30px;
  top: 150px;
  width: 40px;
  height: 40px;
}

.delete {
  position: absolute;
  right: -30px;
  top: 50%;
  width: 40px;
  height: 40px;
}
</style>